<template>
  <div class="anti-induled__payment">
    <AntiInduled
      branch="payment"
      :type="antiInduledType"
      :customer="customer"
      @close="close"
      @changeData="changeData"
      @submit="submit"
      @confirm="confirm"
      @cancel="cancel"
      v-if="antiInduledType || antiInduledType === 0"
      :isClient="true"
    ></AntiInduled>
  </div>
</template>

<script>
import AntiInduled from '@/components/antiIndulged/index.vue';
import { mapActions, mapState, mapMutations } from 'vuex';
import { isAndroid } from '@/libs/utils';
import { 
  registReturnGameFunction,
  registFinishedBindIDCardFunction
} from '@/bridge/AppJsBridge';
import { idBind } from '@/api/user';

export default {
  name: '',
  data() {
    return {
      antiInduledType: null,
      customer: '',
      antiIndulgedPayInfo: null,
      isPage: false // 是否是通过路由而非支付页面调用，提供给发版署测试防沉迷的包使用
    };
  },
  async mounted() {
    await this.dataInit();
    this.initState();
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      device_info: state => state.user.device_info
    })
  },
  components: {
    AntiInduled
  },
  methods: {
    ...mapActions({
      realNameVerify: 'user/realNameVerify',
      getUserCache: 'user/getCacheState',
      cacheUserState: 'user/cacheState'
    }),
    ...mapMutations({
      changeGlobalState: 'global/CHANGE_STATE',
      changeUserState: 'user/CHANGE_STATE',
    }),
    close() {
      registReturnGameFunction(null)
    },
    initState() {
      const { name, query } = this.$route;
      if (name !== 'client.antiIndulgedPayment') {
        const { antiIndulgedPayInfo } = this.$store.state.user;
        if (antiIndulgedPayInfo) {
          this.antiIndulgedPayInfo = antiIndulgedPayInfo;
          this.antiInduledType = antiIndulgedPayInfo.code;
          this.customer = antiIndulgedPayInfo.customer;
        }
      } else {
        this.isPage = true;
        // 非加载在支付页的情况，提供单独的提示页给版署包使用
        this.antiInduledType = query.type;
      }
    },
    async dataInit() {
      const cacheList = [
        'user_id',
        'appkey',
        'channel',
        'extra_data',
        'device_info',
        'access_token',
        'is_audit_packet',
        'antiInduled_customer'
      ];
      await this.getUserCache(cacheList);
    },
    confirm(type) {
      this.$emit('antiIndulgedClose');
      if (this.isPage) this.close();
    },
    cancel() {
      this.$emit('antiIndulgedClose');
      if (this.isPage) this.close();
    },
    changeData(key, value) {
      this[key] = value;
    },
    async submit(form, flag) {
      form = {
        ...form,
        uid: this.userState.user_id,
        jh_app_id: this.userState.appkey,
        access_token: this.userState.access_token
      };
      const { id_card_name, id_card_num } = form;
      const verifyResult = await this.realNameVerify({ id_card_name, id_card_num });
      if (verifyResult) {
        // 验证失败
        this.$toast(verifyResult);
        if (flag) this.$refs.antiInduled.rebind();
      } else {
        try {
          const r = await idBind(form); 
          if (r.content.id_status == 2) {
            this.notifyRealName(r.content.id_status, 0);
            this.antiInduledType = 1;
          } else {
            // 成年人实名认证成功通知客户端
            this.notifyRealName(r.content.id_status, 0);
            this.$toast('认证成功')
            setTimeout(() => {
              this.$emit('antiIndulgedClose');
              if (this.isPage) this.close();
            }, 2000);
          }
        } catch (error) {
          if (flag) this.$refs.antiInduled.rebind();
        }
      }
    },
    /**
     * @param {number} id_status 参照实名认证接口
     * @param {number} close 是否关闭当前webview
     */
    notifyRealName(id_status, close) {
      registFinishedBindIDCardFunction({ id_status, close })
    }
  }
};
</script>

<style lang="scss" scoped>
.anti-induled__payment {
  width: 100%;
  height: 100%;
}
</style>